module.exports = __webpack_public_path__ + "static/img/017.c3b3c2de.png";